import React from 'react';
import { cn } from './cn';

/**
 * Material Symbols (Rounded) — ต้องโหลดฟอนต์ไอคอนใน document head:
 * <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0,0" rel="stylesheet" />
 *
 * กติกา: ไอคอนห้ามยืนสื่อความหมายเดี่ยว ๆ ต้องมี label หรือ aria-label กำกับ
 */
export interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** ชื่อไอคอนของ Material Symbols เช่น 'shopping_cart' */
  name: string;
  /** ขนาดเป็น px */
  size?: number;
  filled?: boolean;
  /** ถ้าไอคอนสื่อความหมายด้วยตัวเอง ให้ใส่ label; ถ้าเป็นการตกแต่งให้ปล่อยว่าง */
  label?: string;
}

export const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  filled = false,
  label,
  className,
  style,
  ...rest
}) => (
  <span
    {...rest}
    className={cn('material-symbols-rounded select-none', className)}
    role={label ? 'img' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
    style={{
      fontSize: size,
      lineHeight: 1,
      fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' ${size}`,
      ...style,
    }}
  >
    {name}
  </span>
);
